module.exports = "<p>\n  Loging you out\n</p>\n"